import { actionTypes } from '../actions/menu-items';
import { layout as defaultState } from './default.json';

const handlers = {
  [actionTypes.MENU_ITEMS_GET_ERROR]: (state, action) => ({
    ...state,
    error: action.error.message,
    inProgress: false,
  }),
  [actionTypes.MENU_ITEMS_GET_IN_PROGRESS]: state => ({
    ...state,
    inProgress: true,
  }),
  [actionTypes.MENU_ITEMS_GET_SUCCESS]: (state, action) => ({
    ...state,
    inProgress: false,
    menuItems: action.list,
  }),
};

export default (state = defaultState, action) => {
  const handler = handlers[action.type];
  return handler ? handler(state, action) : state;
};
